/* eslint-disable max-len */

import React from 'react';
import { useTranslation } from 'react-i18next';

import { stakeholderModel } from '../../../constants';
import { LabeledSelect } from '..';

export const StakeholderType = ({ label, id, onChange, withAsterisks, showAll = true, ...props }) => {

  const [ t ] = useTranslation();

  const options = [
    ...(showAll ? [ { value: stakeholderModel.TYPE_VALUES.ALL, text: t('fields.stakeholderType.all') } ] : []),
    { value: stakeholderModel.TYPE_VALUES.MANUFACTURER, text: t('fields.stakeholderType.manufacturer') },
    { value: stakeholderModel.TYPE_VALUES.WAREHOUSE, text: t('fields.stakeholderType.warehouse') },
    { value: stakeholderModel.TYPE_VALUES.PHARMACY, text: t('fields.stakeholderType.pharmacy') },
    { value: stakeholderModel.TYPE_VALUES.CONSUMPTION_CENTER, text: t('fields.stakeholderType.consumptionCenter') },
    { value: stakeholderModel.TYPE_VALUES.REIMBURSEMENT_AGENCY, text: t('fields.stakeholderType.reimbursementAgency') }
  ];


  // const getTypeById = typeId => {
  //   for (const [ key, val ] of Object.entries(stakeholderModel.TYPE_VALUES)) {
  //     // eslint-disable-next-line eqeqeq
  //     if (val == typeId) {
  //       if (key.includes('_')) {
  //         const index = key.indexOf('_');
  //         const fixedKey = key.substring(0, index).toLocaleLowerCase() + key.charAt(index + 1).toUpperCase() + key.substring(index + 2).toLocaleLowerCase();

  //         return t(`fields.stakeholderType.${fixedKey}`);
  //       }

  //       return t(`fields.stakeholderType.${key.toLocaleLowerCase()}`);
  //     }
  //   }

  //   return false;
  // };

  return (
    <LabeledSelect
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      searchDelay={ 0 }
      options={ options }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedType') }
      withAsterisks={ withAsterisks }
      allowClear
      // placeholder={ value ? getTypeById(value) : t('fields.types.placeholder') }
      // value={ getTypeById(value) ?? false }
      { ...props }
    />
  );
};
